export const LOGOUT_ACTION = "LOGOUT";
export const REPORT_TYPES = ["InspectionReport", "SafetyReport"];
export const INVOICE_RECIPIENTS_STATUS = ["INVITED", "ACCEPTED", "REJECTED"];
